import debounce from 'lodash/debounce';
import {useEffect, useRef, useState} from 'react';

export const useChartPosition = () => {
  const pieRef = useRef<HTMLDivElement | null>(null);
  const [chartPosition, setChartPosition] = useState<DOMRect | null>(null);

  useEffect(() => {
    const updatePosition = debounce(() => {
      if (pieRef.current) {
        setChartPosition(pieRef.current.getBoundingClientRect());
      }
    }, 300);

    updatePosition();
    window.addEventListener(`scroll`, updatePosition, true);
    window.addEventListener(`resize`, updatePosition);

    return () => {
      window.removeEventListener(`scroll`, updatePosition, true);
      window.removeEventListener(`resize`, updatePosition);
    };
  }, []);

  return {ref: pieRef, rect: chartPosition};
};
